export const experimentConfig = {
  debug: false,
  dataEndpoint: "/experiment-data",
  prolificRedirectUrl:
    "https://app.prolific.com/submissions/complete?cc=C1DT32OR",
};
